/**
 * Take the array that we
 * receive from the multiselect component
 * and return only its "id" attributes
 * 
 * Example:
 * 
 * qualifications: [{id: <UUID>, description: "Station A"}]
 * returns
 * [<UUID>]
 * 
 * @param arrayOfObjects
 */
function trimEverythingButIds(arrayOfObjects): string[] {
  if (!arrayOfObjects) {
    return [];
  }

  return arrayOfObjects.map(object => object.id);
}

export const multiselectHelper = {
  trimEverythingButIds,
}